/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ app: NonNullable<unknown> }} Common_Header_Tools_All_DetailInputs */

const en_common_header_tools_all_detail = /** @type {(inputs: Common_Header_Tools_All_DetailInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Generators and discovery tools by ${i?.app}`)
};

const zh_common_header_tools_all_detail = /** @type {(inputs: Common_Header_Tools_All_DetailInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.app} 的生成器与发现工具`)
};

/**
* | output |
* | --- |
* | "Generators and discovery tools by {app}" |
*
* @param {Common_Header_Tools_All_DetailInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_header_tools_all_detail = /** @type {((inputs: Common_Header_Tools_All_DetailInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Header_Tools_All_DetailInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_header_tools_all_detail(inputs)
	return zh_common_header_tools_all_detail(inputs)
});
export { common_header_tools_all_detail as "common.header.tools.all.detail" }